import { useNavigate } from "react-router-dom";
import { Breadcrumb, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const GuideProcessing = () => {
	const navigate = useNavigate();

	return (
		<div className="products-details-screen-container">
			<Breadcrumb
				className="products-breadcrumbs"
				items={[
					{
						title: "Guides",
						onClick: () => navigate("/guides")
					},
					{
						title: "Create Guide"
					}
				]}
			/>
			<div className="guide-processing-container">
				<div className="guide-processing-title">We’re turning your video into a step-by-step Guide.</div>
				<div className="guide-processing-description">Grab a coffee. We’ll let you know when it’s ready to review!</div>
				<Spin className="guide-processing-spinner" indicator={<LoadingOutlined style={{ fontSize: 72 }} spin />} />
			</div>
		</div>
	);
};

export default GuideProcessing;
